module.exports = __webpack_public_path__ + "img/receipt-red.d42acfdc.svg";